import React from "react";
import { usePublicConfig } from "./PublicConfigProvider";

export function Footer() {
  const cfg = usePublicConfig();
  const attribution = cfg.program === "boys"
    ? "The American Legion, Department of Maryland"
    : "The American Legion Auxiliary, Department of Maryland";
  return (
    <footer className="bg-slate-100 border-t border-slate-200 mt-12">
      <div className="max-w-4xl mx-auto px-4 py-6 text-sm text-slate-600 space-y-1">
        <p>
          {cfg.programName} — sponsored by {attribution}.
        </p>
        <p>
          Final details including session location:{" "}
          <a className="underline text-program" href={cfg.programInfoUrl} target="_blank" rel="noreferrer">
            {cfg.programInfoUrl}
          </a>
        </p>
        <p>
          Questions?{" "}
          <a className="underline text-program" href={`mailto:${cfg.supportEmail}`}>
            {cfg.supportEmail}
          </a>
        </p>
      </div>
    </footer>
  );
}
